import { render, staticRenderFns } from "./TaxationSales.vue?vue&type=template&id=0f45668c&scoped=true&"
import script from "./TaxationSales.vue?vue&type=script&lang=js&"
export * from "./TaxationSales.vue?vue&type=script&lang=js&"
import style0 from "./TaxationSales.vue?vue&type=style&index=0&id=0f45668c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45668c",
  null
  
)

export default component.exports